const faqs = [
  {
    question: "Does Iowa have its own regional passport agency?",
    answer:
      "Iowa does not have a regional passport agency within the state. The nearest regional passport agency for most Iowa travelers is the Chicago Passport Agency, located in downtown Chicago. Depending on where you are in Iowa, the Minneapolis or Detroit agencies may also be options. Using an approved courier service like Fast Passport Center eliminates the need to travel to a regional agency.",
  },
  {
    question: "How fast can I get a passport in Iowa?",
    answer:
      "With Fast Passport Center's courier service, Iowa travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Iowa?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office or county clerk). Many post offices across Iowa offer passport acceptance services, though appointments are often required. Renewals for adults can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which Iowa airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Major Iowa airports with international connections include Des Moines (DSM), Cedar Rapids (CID), and Sioux City (SUX). Most international flights from Iowa connect through Chicago, Denver, or Minneapolis.",
  },
  {
    question: "Can I renew my passport by mail from Iowa?",
    answer:
      "Yes, if you meet the renewal requirements: your most recent passport was issued when you were 16 or older, it was issued within the last 15 years, it is undamaged, and it was issued in your current name (or you can provide legal documentation of a name change). Otherwise, you will need to apply in person at a local acceptance facility.",
  },
  {
    question: "Where is the best place to get a passport photo in Iowa?",
    answer:
      "CVS, Walgreens, and UPS Store locations are widely available across Iowa and offer passport photo services. Most walk-ins are accepted, though calling ahead is recommended. Walmart photo centers in larger cities like Des Moines, Cedar Rapids, and Davenport also offer passport photos. Always verify the photo meets official requirements before submitting.",
  },
];

export { faqs };

export default function IowaFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Iowa Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Iowa.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}